<template>
  <div class="container">

    <div class="row">

      <div id="references" class="col-lg-5 ">
        <div class="your_results">
          <div class="col-12 white-hr">
            <hr>
          </div>
          <div class="row ">

            <div class="row ">

              <h3 class="text-center text-white">Referencia Personal 1</h3>
              <div class="col-12 row ">
                <h6 class="text-white col-3 p-3">Nombre</h6>
                <br>
                <input type="text" class="form-control col-9 p-3" v-model="referenceData.data1.name"
                  :class="{ 'error': $v.referenceData.data1.name.$dirty && $v.referenceData.data1.name.$invalid }"
                  @blur="$v.referenceData.data1.name.$touch();
                  referenceData.data1.name = $event.target.value.toUpperCase()">
              </div>

              <div class="col-12 row">
                <h6 class="text-white col-3 p-3">Numero</h6>
                <input type="tel" class="form-control col-9 p-3" v-only-numbers v-model="referenceData.data1.phone"
                  @blur=" $v.referenceData.data1.phone.$touch();"
                  :class="{ 'error': $v.referenceData.data1.phone.$dirty && $v.referenceData.data1.phone.$invalid }">
              </div>
              <div class="col-lg-4 mt-1 ">
                <!-- <h6 class="text-white py-1">Tipo referencia</h6>
                <select class="form-control" id="type_reference1" name="type_reference1">
                  <option value="Familiar">Familiar</option>
                  <option value="Laboral">Laboral</option>
                  <option value="Personal">Personal</option>
                </select>-->
              </div>
            </div>
            <div class="col-12 white-hr">
              <hr>
            </div>
            <div class="row">
              <h3 class="text-center text-white">Referencia Personal 2</h3>
              <!--<hr>-->
              <div class="tittle la pt-0 pb-2 m-1">
                <h2></h2>
              </div>
              <div class="col-12 row">
                <h6 class="text-white col-3 p-3">Nombre</h6>
                <br>
                <input type="text" class="form-control col-9 p-3" v-model="referenceData.data2.name"
                  :class="{ 'error': $v.referenceData.data2.name.$dirty && $v.referenceData.data2.name.$invalid }"
                  @blur="$v.referenceData.data2.name.$touch();
                  referenceData.data2.name = $event.target.value.toUpperCase()">
              </div>
              <div class="col-12 row">
                <h6 class="text-white col-3 p-3">Numero</h6>
                <input type="tel" class="form-control col-9 p-3" v-only-numbers v-model="referenceData.data2.phone"
                  @blur=" $v.referenceData.data2.phone.$touch();"
                  :class="{ 'error': $v.referenceData.data2.phone.$dirty && $v.referenceData.data2.phone.$invalid }">
              </div>
              <div class="col-lg-4 mt-1">
                <!-- <h6 class="text-white py-1">Tipo referencia</h6>
                <select class="form-control" id="type_reference2" name="type_reference2">
                  <option value="Familiar">Familiar</option>
                  <option value="Laboral">Laboral</option>
                  <option value="Personal">Personal</option>
                </select>-->
              </div>
            </div>
            <div class="col-12 white-hr">
              <hr>
            </div>
            <div class="row">
              <h3 class="text-center text-white">Referencia Familiar</h3>
              <!--<hr>-->
              <div class="tittle la pt-0 pb-2 m-1">
                <h2></h2>
              </div>
              <div class="col-12 row">
                <h6 class="text-white col-3 p-3">Nombre</h6>
                <input type="text" class="form-control col-9 p-3" v-model="referenceData.data.name"
                  :class="{ 'error': $v.referenceData.data.name.$dirty && $v.referenceData.data.name.$invalid }" @blur="$v.referenceData.data.name.$touch();
                  referenceData.data.name = $event.target.value.toUpperCase()">
              </div>
              <div class="col-12 row">
                <h6 class="text-white col-3 p-3">Numero</h6>
                <br>
                <input type="tel" class="form-control col-9 p-3" v-only-numbers v-model="referenceData.data.phone"
                  @blur=" $v.referenceData.data.phone.$touch();"
                  :class="{ 'error': $v.referenceData.data.phone.$dirty && $v.referenceData.data.phone.$invalid }">
              </div>
              <div class="col-lg-4 mt-1">
                <!--<h6 class="text-white py-1">Tipo referencia</h6>
                <select class="form-control" id="type_reference" name="type_reference">
                  <option value="Familiar">Familiar</option>
                  <option value="Laboral">Laboral</option>
                  <option value="Personal">Personal</option>
                </select>-->
              </div>
            </div>
            <div class="col-12 white-hr">
              <hr>
            </div>
          </div>

        </div>
      </div>


      <div id="AboutYou" class="col-lg-7 back-form">
        <div class="row">
          <div class="tittle la pt-0 pb-2 m-1">
            <h2>Queremos conocerte más</h2>
          </div>
          <div class="col-lg-6 row m-0">
            <b class="col-form-label col-12 b">¿A qué te dedicas?</b>
            <select class="form-control p-2  col-12" id="employment_situation" name="employment_situation"
              v-on:change="onChangeEmploymentSituation">
              <option value="Empleado">Empleado</option>
              <option value="Trabajo por mi cuenta">Trabajo por mi cuenta</option>
              <option value="Dueño de negocio">Dueño de negocio</option>
              <option value="Profesionista independiente">Profesionista independiente</option>
            </select>
          </div>
          <div id="div_ocupation" class="col-lg-6 row m-0">
            <b class="col-form-label col-12">Puesto</b>
            <select class="form-control p-2  col-12" id="ocupation" name="ocupation"
              v-model="employmentData.data.ocupation" :class="{
                error:
                  $v.employmentData.data.ocupation.$dirty &&
                  $v.employmentData.data.ocupation.$invalid
              }" required @blur="$v.employmentData.data.ocupation.$touch()">
              <option value="">Seleccione una opción</option>
              <option value="Ventas/operativo">Dueño</option>
              <option value="Operativo">Operativo</option>
              <option value="Administrativo">Administrativo</option>
              <option value="Gerencial">Gerencial</option>
            </select>
          </div>

          <div id="div_workplace" class="col-lg-6 row m-0 d-none">
            <b class="col-form-label col-12">Lugar de trabajo</b>
            <select class="form-control p-2  col-12" id="workplace" name="workplace"
              v-model="employmentData.data.workplace" :class="{
                error:
                  $v.employmentData.data.workplace.$dirty &&
                  $v.employmentData.data.workplace.$invalid
              }" required @blur="$v.employmentData.data.workplace.$touch()">
              <option value="">Seleccione una opción</option>
              <option value="Local fijo">Local fijo</option>
              <option value="No tiene local">No tiene local</option>
              <option value="Local semifijo">Local semifijo</option>
              <option value="Ambulante">Ambulante</option>
            </select>
          </div>

          <div class="col-lg-6 row m-0">
            <b class="col-form-label col-12">Nombre de la empresa</b>
            <input class="form-control" id="company_name" v-model="employmentData.data.company_name" :class="{
              error:
                $v.employmentData.data.company_name.$dirty &&
                $v.employmentData.data.company_name.$invalid
            }" required @blur="$v.employmentData.data.company_name.$touch()" />
          </div>
          <div class="col-lg-6 row m-0">
            <b class="col-form-label col-12">Antigüedad en tu empleo</b>
            <select class="form-control p-2  col-12" id="antique_employment" name="antique_employment">
              <option value="0">Menos de un año</option>
              <option value="1">1 año</option>
              <option value="2">2 años</option>
              <option value="3">3 años</option>
              <option value="4">4 años</option>
              <option value="5">5 años</option>
              <option value="6">6 años</option>
              <option value="7">7 años</option>
              <option value="8">8 años</option>
              <option value="9">9 años</option>
              <option value="10">10 años o más</option>
            </select>
          </div>

          <div class="col-lg-7 row m-0">
            <b class="col-form-label col-12">Direccion de la empresa</b>
            <input class="form-control" id="company_address" v-model="employmentData.data.company_address" :class="{
              error:
                $v.employmentData.data.company_address.$dirty &&
                $v.employmentData.data.company_address.$invalid
            }" required @blur="$v.employmentData.data.company_address.$touch()" />
          </div>

          <div class="col-lg-5 row m-0">
            <b class="col-form-label col-12">Ingresos mensuales</b>
            <div class="input-group-prepend ">
              <div class="input-group-text  form-control">$</div>
            </div>
            <div class="input-group-prepend col-10 p-0">
              <input type="text" class="form-control col-12" id="net_income" name="net_income" v-only-numbers
                v-model="masck.net_income" v-mask="numberMask" :class="{
                  error:
                    $v.employmentData.data.net_income.$dirty &&
                    $v.employmentData.data.net_income.$invalid
                }" @blur="
                  $v.employmentData.data.net_income.$touch();
                employmentData.data.net_income = masck.net_income.replace(
                  /\D+/g,
                  ''
                );
                " />
            </div>
          </div>

          <small class="col-12  m-1 pl-3 text-orange">
            (calle, numero, colonia, municipio estado)
          </small>

          <div class="col-lg-6 row m-0">
            <b class="col-form-label col-12">Estado civil</b>
            <select class="form-control p-2  col-12" id="estado-civil">
              <option value="Soltero (a)">Soltero (a)</option>
              <option value="Casado (a)">Casado (a) / Unión libre</option>
              <option value="Divorciado (a)">Divorciado (a)</option>
              <option value="Viudo (a)">Viudo (a)</option>
            </select>
          </div>
          <div id="div_living_since" class="col-lg-6 row m-0 ">
            <b class="col-form-label col-12">Antigüedad en tu domicilio</b>
            <select class="form-control p-2  col-12" id="living_since" name="living_since">
              <option value="0">Menos de un año</option>
              <option value="1">1 año</option>
              <option value="2">2 años</option>
              <option value="3">3 años</option>
              <option value="4">4 años</option>
              <option value="5">5 años</option>
              <option value="6">6 años</option>
              <option value="7">7 años</option>
              <option value="8">8 años</option>
              <option value="9">9 años</option>
              <option value="10">10 años o más</option>
            </select>
          </div>
          <div id="div_economic_dependents" class="col-lg-6 row m-0">
            <b class="col-form-label col-12">Dependientes económicos</b>
            <select class="form-control p-2  col-12" id="economic_dependents" name="economic_dependents">
              <option value="0">No tengo</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5 o más</option>
            </select>
          </div>
          <div class="col-lg-6 row m-0">
            <b class="col-form-label col-12">Situación de tu vivienda</b>
            <select class="form-control p-2 col-12" id="current_living" v-on:change="onChangeCurrenLiving">
              <option value="Rentada">Rentada</option>
              <option value="Propia">Propia</option>
              <option value="Propia pagando">Propia pagando</option>
              <option value="Prestada de familiares">Prestada de familiares</option>
            </select>
          </div>
          <div id="div_monthly_rent" class="col-lg-6 row m-0">
            <b class="col-form-label col-12">¿Cuánto pagas al mes?</b>
            <div class="input-group col-12 p-0">
              <div class="input-group-prepend">
                <div class="input-group-text  form-control">$</div>
              </div>
              <input type="text" class="form-control col-12" id="monthly_rent" name="monthly_rent" v-only-numbers
                v-model="masck.monthly_rent" v-mask="numberMask" :class="{
                  error:
                    $v.addressData.data.monthly_rent.$dirty &&
                    $v.addressData.data.monthly_rent.$invalid
                }" @blur="
                  $v.addressData.data.monthly_rent.$touch();
                addressData.data.monthly_rent = masck.monthly_rent.replace(
                  /\D+/g,
                  ''
                );
                " />
            </div>
          </div>

          <div class="form-group col-6"></div>
          <div class="form-group col-12"></div>

          <div class="form-group col-6">
            <a class="btnBackStep1 theme_btn btn" id="js-contact-btn scroll-step" v-on:click="onPrev()"
              href="/create-account">
              Anterior
            </a>
          </div>
          <div class="form-group col-6">
            <button class="btnBackStep1 theme_btn btn float-right scroll-step" :disabled="($v.employmentData.data.ocupation.$invalid &&
              $v.employmentData.data.workplace.$invalid) ||
              $v.employmentData.data.company_name.$invalid
              " v-on:click="saveReference(); onNext();" id="js-contact-btn scroll-step">
              Siguiente
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  required,
  minValue,
  maxLength,
  minLength
} from "vuelidate/lib/validators";
import Environments from "../../environments/Environment";
import createNumberMask from "text-mask-addons/dist/createNumberMask";


const numberMask = createNumberMask({
  prefix: "",
  includeThousandsSeparator: true,
  allowNegative: false
});

export default {
  name: "AboutYou",
  data() {
    return {
      CatlogoLotes: [],
      TASA: Environments.TASA,
      GPS: Environments.GPS,
      SEGURODEUDOR: Environments.SEGURODEUDOR,
      numberMask,
      lastYears: [],
      vehicleBrand: [],
      models: [],
      brands: [],
      versions: [],
      descriptions: [],
      noCar: 0,
      masck: {
        monthly_rent: 0,
        vehicle_Hitch: 0,
        dependent: 0,
        net_income: 0,
        desired_payment: 0,
        monthly_education_expenditure: 0,
        requested_amount_credit: 0,
        desired_hitch: 0,
        extra_income: 0,
      },
      employmentData: {
        data: {
          employment_situation: "fixed",
          antique: "1",
          ocupation: "",
          vacation_per_year: 0,
          education: 0,
          line_of_business: "",
          company_name: "",
          company_address: "",
          workplace: ""
        }
      },
      quote_credit: {
        data: {
          user_id: "",
          vehicle_model: "",
          vehicle_brand: "",
          vehicle_version: "2020",
          vehicle_description: "",
          purpose_of_vehicle: "",
          vehicle_type: "",
          lote: ""
        }
      },
      detailsData: {
        data: {
          marital_status: "Soltero (A)",
          comment: ''
        }
      },
      addressData: {
        data: {
          current_living: "0",
          living_since: "0",
          monthly_rent: "0"
        }
      },
      referenceData: {
        data: {
          name: '',
          phone: '',
          type: 'Familiar',
        },
        data1: {
          name: '',
          phone: '',
          type: 'Personal',
        },
        data2: {
          name: '',
          phone: '',
          type: 'Personal',
        },
      },
      documents: {
        data: {
          clickupTaskId: '',
          ine: '',
          ingreso: '',
          domicilio: ''
        }
      }

    };
  },
  validations() {
    return {
      employmentData: {
        data: {
          net_income: { required },
          extra_income: { required },
          vacation_per_year: { required },
          antique: { required },
          company_name: { required },
          company_address: { required },
          ocupation: { required },
          workplace: { required }
        }
      },
      quote_credit: {
        data: {
          vehicle_model: { required },
          vehicle_brand: { required },
          requested_amount_credit: { required },
          desired_payment: { required },
          vehicle_version: { required, minValue: minValue(2012), $lazy: true },

        }
      },
      detailsData: {
        data: {
          marital_status: { required },
          monthly_education_expenditure: { required },
          economic_dependents: { required }
        }
      },
      addressData: {
        data: {
          monthly_rent: { required }
        }
      },
      referenceData: {
        data: {
          name: { required },
          phone: { required, minValue: minLength(10), maxValue: maxLength(10), $lazy: true }
        },
        data1: {
          name: { required },
          phone: { required, minValue: minLength(10), maxValue: maxLength(10), $lazy: true }
        },
        data2: {
          name: { required },
          phone: { required, minValue: minLength(10), maxValue: maxLength(10), $lazy: true }
        }
      }
    };
  },
  methods: {
    openTaps(evt, taps) {
      this.noCar = 0;
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById(taps).style.display = "block";
      evt.currentTarget.className += " active";
    },
    onPrev() {
      this.preloader();
      this.$emit("previous", {});
      this.preloaderHiden();
    },
    onNext() {
      this.preloader();
      this.quote_credit.data.id = 0;
      this.quote_credit.data.user_id = localStorage.getItem("id");
      this.quote_credit.data.vehicle_model = $("#vehicle_model").val();
      this.quote_credit.data.vehicle_brand = $("#vehicle_brand").val();
      this.quote_credit.data.insurance_payment = $("#insurance_payment").val();
      this.quote_credit.data.vehicle_version = $("#vehicle_version").val();
      this.quote_credit.data.purpose_of_vehicle = $(
        "#purpose_of_vehicle"
      ).val();
      this.quote_credit.data.vehicle_type = $("#vehicle_type").val();

      this.employmentData.data.employment_situation = $(
        "#employment_situation"
      ).val();
      this.employmentData.data.line_of_business = $("#line_of_business").val();
      this.employmentData.data.ocupation = $("#ocupation").val();
      this.employmentData.data.education = $("#education").val();
      this.employmentData.data.antique = $("#antique_employment").val();
      this.employmentData.data.workplace = $("#workplace").val();

      this.detailsData.data.marital_status = $("#estado-civil").val();
      this.detailsData.data.economic_dependents = $(
        "#economic_dependents"
      ).val();
      this.addressData.data.current_living = $("#current_living").val();
      this.addressData.data.living_since = $("#living_since").val();

      this.$UserService.updateEmployement(this.employmentData).then(
        result => {
          this.$UserService.updateDetails(this.detailsData).then(
            result => {
              this.$UserService.updateAddress(this.addressData).then(
                result => {
                  this.$emit("next", {});
                  this.preloaderHiden();
                },
                err => {
                  this.$swal("CUIDADO!", err.msg, "error");
                  this.preloaderHiden();
                }
              );
            },
            err => {
              this.$swal("CUIDADO!", err.msg, "error");
              this.preloaderHiden();
            }
          );
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );

      if (this.noCar == 0) {
        this.$UserService.updateCreditQuotation(this.quote_credit).then(
          result => { },
          err => {
            this.$swal("CUIDADO!", err.msg, "error");
            this.preloaderHiden();
          }
        );
      }

      this.preloaderHiden();
    },
    onChangeVehicleType() {
      this.vehicleBrand = [];
      $("#vehicle_brand").val("");
      var vehicle = document.getElementById("vehicle_type");
      if (vehicle.value != "Camión") {
        $(".type_vehicle").prop("disabled", false);
        $(".type_truck").prop("disabled", true);
      } else {
        $(".type_vehicle").prop("disabled", true);
        $(".type_truck").prop("disabled", false);
      }
    },
    onChangeBrand() {
      this.quote_credit.data.vehicle_brand = $("#vehicle_brand").val();
      if (this.vehicleBrand.length == 0) {
        for (var option of document.getElementById("vehicle_brand_list")
          .options) {
          this.vehicleBrand.push(option.value);
        }
      }
      if (
        !this.datalistValidator(
          this.quote_credit.data.vehicle_brand,
          this.vehicleBrand
        )
      ) {
        $("#vehicle_brand").val("");
        this.quote_credit.data.vehicle_brand = "";
      }
    },
    onChangeLote() {
      this.quote_credit.data.lote = $("#lote").val();
      if (this.quote_credit.data.lote != "" &&
        !this.datalistValidator(
          this.quote_credit.data.lote,
          this.CatlogoLotes
        )
      ) {
        $("#lote").val("");
        this.quote_credit.data.lote = "";
      }
    },
    datalistValidator(modelname, modelList) {
      var result = modelList.indexOf(modelname) > -1;
      if (!result) {
        this.$swal("Cuidado!", "Seleccione un elemento de la lista", "warning");
      }
      return result;
    },
    onChangeCurrenLiving() {
      var living = document.getElementById("current_living");
      if (living.value != "Rentada" && living.value != "Propia pagando") {
        this.addressData.data.monthly_rent = "0";
        this.masck.monthly_rent = "0";
        document.getElementById("div_monthly_rent").classList.add("d-none");
      } else {
        document.getElementById("div_monthly_rent").classList.remove("d-none");
      }
    },
    onChangeEmploymentSituation() {
      var situation = document.getElementById("employment_situation");
      if (
        (situation.value == "Dueño de negocio" ||
          situation.value == "Trabajo por mi cuenta")
      ) {
        this.employmentData.data.ocupation = "";
        $("#ocupation").val("");
        document.getElementById("div_ocupation").classList.add("d-none");
        document.getElementById("div_workplace").classList.remove("d-none");
      } else {
        this.employmentData.data.workplace = "";
        $("#workplace").val("");
        document.getElementById("div_ocupation").classList.remove("d-none");
        document.getElementById("div_workplace").classList.add("d-none");
      }
    },
    getLastYears() {
      var year = new Date().getFullYear();
      for (let index = 0; index < 11; index++) {
        this.lastYears.push(year - index);
      }
    },
    getEmployement() {
      this.$UserService.getEmployement().then(
        result => {
          if (result.data.length > 0) {
            this.employmentData.data.net_income = result.data[0].net_income;
            this.masck.net_income = result.data[0].net_income;
            this.employmentData.data.employment_situation =
              result.data[0].employment_situation;
            this.employmentData.data.line_of_business =
              result.data[0].line_of_business;
            this.employmentData.data.ocupation = result.data[0].ocupation;
            this.employmentData.data.education = result.data[0].education;
            this.employmentData.data.antique = result.data[0].antique;
            this.employmentData.data.company_name = result.data[0].company_name;
            this.employmentData.data.company_address = result.data[0].company_address;
            this.employmentData.data.workplace = result.data[0].workplace;
            setTimeout(() => {
              $("#employment_situation").val(
                this.employmentData.data.employment_situation
              );
              $("#employment_situation").niceSelect("update");
              $("#line_of_business").val(
                this.employmentData.data.line_of_business
              );
              $("#line_of_business").niceSelect("update");
              $("#ocupation").val(this.employmentData.data.ocupation);
              $("#ocupation").niceSelect("update");
              $("#education").val(this.employmentData.data.education);
              $("#education").niceSelect("update");
              $("#antique_employment").val(this.employmentData.data.antique);
              $("#antique_employment").niceSelect("update");
              $("#workplace").val(this.employmentData.data.workplace);
              $("#workplace").niceSelect("update");
              this.onChangeEmploymentSituation();
            }, 300);
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getQuoteCredit() {
      this.$UserService.getCreditQuotation().then(
        result => {
          if (result.data.length > 0) {
            this.quote_credit.data.vehicle_brand = result.data[0].vehicle_brand;
            this.quote_credit.data.vehicle_model = result.data[0].vehicle_model;
            this.quote_credit.data.vehicle_version =
              result.data[0].vehicle_version;
            this.quote_credit.data.purpose_of_vehicle =
              result.data[0].purpose_of_vehicle;
            this.quote_credit.data.insurance_payment =
              result.data[0].insurance_payment;
            this.quote_credit.data.lote =
              result.data[0].lote;

            setTimeout(() => {
              $("#vehicle_brand").val(this.quote_credit.data.vehicle_brand);
              $("#vehicle_brand").niceSelect("update");
              $("#purpose_of_vehicle").val(
                this.quote_credit.data.purpose_of_vehicle
              );
              $("#purpose_of_vehicle").niceSelect("update");
              $("#insurance_payment").val(
                this.quote_credit.data.insurance_payment
              );
              $("#insurance_payment").niceSelect("update");
              $("#vehicle_version").val(this.quote_credit.data.vehicle_version);
              $("#vehicle_version").niceSelect("update");

            }, 300);
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getDetails() {
      this.$UserService.getDetails().then(
        result => {
          if (result.data.length > 0) {
            this.detailsData.data.marital_status =
              result.data[0].marital_status;
            this.detailsData.data.were_clients = result.data[0].were_clients;
            this.detailsData.data.economic_dependents =
              result.data[0].economic_dependents;

            setTimeout(() => {
              $("#estado-civil").val(this.detailsData.data.marital_status);
              $("#estado-civil").niceSelect("update");
              $("#economic_dependents").val(
                this.detailsData.data.economic_dependents
              );
              $("#economic_dependents").niceSelect("update");
            }, 300);
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getAddress() {
      this.$UserService.getAddress().then(
        result => {
          if (result.data.length > 0) {
            this.addressData.data.current_living =
              result.data[0].current_living;
            this.addressData.data.living_since = result.data[0].living_since;
            this.addressData.data.monthly_rent = result.data[0].monthly_rent;
            this.masck.monthly_rent = result.data[0].monthly_rent;
            setTimeout(() => {
              $("#current_living").val(this.addressData.data.current_living);
              $("#current_living").niceSelect("update");
              $("#living_since").val(this.addressData.data.living_since);
              $("#living_since").niceSelect("update");
            }, 300);
            setTimeout(() => {
              this.onChangeCurrenLiving();
            }, 300);
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getLote() {
      this.$LoteService.getLote().then(
        result => {
          if (result.data.length > 0) {
            this.CatlogoLotes = result.data.map(item => item["nombre"]);
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    noQuotation() {
      this.noCar = 1;
      this.quote_credit.data.vehicle_model = "";
      this.quote_credit.data.vehicle_brand = "";
      this.quote_credit.data.vehicle_version = "";
      this.quote_credit.data.vehicle_description = "";
      this.quote_credit.data.vehicle_type = "";
    },
    getReference() {
      this.$UserService.getReference().then((result) => {
        if (result.data.length > 0) {
          this.referenceData.data1.name = result.data[0].name;
          this.referenceData.data1.phone = result.data[0].phone;
          this.referenceData.data1.type = result.data[0].type;
        }
        if (result.data.length >= 2) {
          this.referenceData.data2.name = result.data[1].name;
          this.referenceData.data2.phone = result.data[1].phone;
          this.referenceData.data2.type = result.data[1].type;
        }
        if (result.data.length >= 3) {
          this.referenceData.data.name = result.data[2].name;
          this.referenceData.data.phone = result.data[2].phone;
          this.referenceData.data.type = result.data[2].type;
        }
        // setTimeout(() => {
        //   ;
        //   $('#type_reference1').val(this.referenceData.data1.type);
        //   $('#type_reference1').niceSelect('update');
        //   $('#type_reference2').val(this.referenceData.data2.type);
        //   $('#type_reference2').niceSelect('update');
        //   $('#type_reference').val(this.referenceData.data.type);
        //   $('#type_reference').niceSelect('update');
        // }, 300);
      }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
    },
    saveReference() {
      this.preloader();

      // this.referenceData.data1.type = $('#type_reference1').val();
      // this.referenceData.data2.type = $('#type_reference2').val();
      // this.referenceData.data.type = $('#type_reference').val();

      this.$UserService.updateReference({ data: this.referenceData.data1 }).then((result) => {
        this.$UserService.updateReference({ data: this.referenceData.data2 }).then((result) => {
          this.$UserService.updateReference({ data: this.referenceData.data }).then((result) => {
            this.preloaderHiden();
          }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
        }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
      }, (err) => { this.$swal("CUIDADO!", err.msg, 'error'); this.preloaderHiden(); });
    },
    preloader() {
      $(".preloader").fadeIn();
      $(".preloader")
        .delay(10)
        .fadeIn("slow");
    },
    preloaderHiden() {
      $(".preloader").fadeOut();
      $(".preloader")
        .delay(10)
        .fadeOut("slow");
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  created() {
    this.getReference()
    this.getLote();
    this.getLastYears();
    this.getEmployement();
    this.getDetails();
    this.getAddress();
    this.getQuoteCredit();
  }
};
</script>

<style lang="scss">
.error {
  border-color: red;
}

.nice-select .current {
  width: -webkit-fill-available !important;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

select option[disabled] {
  display: none;
}
</style>

<style>
body {
  font-family: Arial;
}

/* Style the tab */
.tab {
  overflow: hidden;
  border: 1px solid #ccc;
  background-color: transparent;
}

/* Style the buttons inside the tab */
.tab button {
  background-color: inherit;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  transition: 0.3s;
  font-size: 17px;
}

/* Change background color of buttons on hover */
.tab button:hover {
  background-color: #55988D;
}

/* Create an active/current tablink class */
.tab button.active {
  background-color: rgb(245, 144, 25);
}

/* Style the tab content */
.tabcontent {
  display: none;
  padding: 6px 12px;
  border: 1px solid #214652;
  border-top: none;
}

.text-orange {
  color: #f59019;
}
</style>



// WEBPACK FOOTER //
// src/views/GrayZone/aboutYou.vue